import { put } from "redux-saga/effects";

import * as action from "../action";

export default function* ({ payload: { display_event } }) {
  yield put(action.displayEventReceived(display_event));
}
